import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { useAssetTreeQuery } from '@services/useAssetTreeQuery';

const RedirectFromOldToNewAi = () => {
  const { redirectAiId } = useParams();
  const { data: assetTreeData } = useAssetTreeQuery();

  const customerId = assetTreeData?.customerLevelId;

  return <Navigate to={`/customer/${customerId}/ai/${redirectAiId}`} />;
};

export default RedirectFromOldToNewAi;
